'use client';

import { Heart } from 'lucide-react';
import { Link } from 'react-router';

const CURRENT_YEAR = new Date().getFullYear();

const PLATFORM_LINKS = [
  { label: 'Inicio', to: '/' },
  { label: 'Torneos', to: '/tournaments' },
  { label: 'Actividades', to: '/activities' },
  { label: 'Iniciar Sesión', to: '/login' },
  { label: 'Dashboard', to: '/dashboard' },
];

export const Footer = () => {
  return (
    <footer className="relative border-t border-border bg-section-alt text-foreground">
      <div className="relative mx-auto max-w-7xl px-6 py-16 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4 group">
              <img src="/core-utils-logo.png" alt="CoreUtils Logo" className="w-10 h-10 object-contain group-hover:scale-110 transition-transform duration-300" />
              <span className="text-xl font-display font-bold text-primary group-hover:opacity-90 transition-opacity duration-300">
                CoreUtils
              </span>
            </Link>
            <p className="text-muted-foreground max-w-md">
              Plataforma esports con torneos, overlays, rosters y herramientas competitivas.
            </p>
            <div className="flex items-center gap-2 mt-4 text-sm text-muted-foreground">
              <span>Hecho con</span>
              <Heart className="w-4 h-4 text-primary fill-current" />
              <span>para la comunidad gaming</span>
            </div>
          </div>

          <div>
            <h3 className="font-display text-lg font-semibold mb-4 text-foreground">Plataforma</h3>
            <ul className="space-y-3">
              {PLATFORM_LINKS.map(({ label, to }) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-muted-foreground hover:text-primary transition-colors duration-200"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-display text-lg font-semibold mb-4 text-foreground">Legal</h3>
            <p className="text-sm text-muted-foreground">
              © {CURRENT_YEAR} CoreUtils. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
